import { render, staticRenderFns } from "./topicsCovered.vue?vue&type=template&id=dfa32574"
import script from "./topicsCovered.vue?vue&type=script&lang=js"
export * from "./topicsCovered.vue?vue&type=script&lang=js"
import style0 from "./topicsCovered.vue?vue&type=style&index=0&id=dfa32574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports